import TrainData from '@/trials/domain/objects/trainData';
import TrainColumn from '@/trials/domain/objects/trainColumn';

/**
 * 学習データの統計情報を計算・保持するクラス
 */
export default class TrainDataStatistics {
    /**
     * 学習データ
     */
    private _trainData: TrainData;

    /**
     * カラムごとの統計情報
     */
    private _statistics: TrainColumn[] = [];

    /**
     * コンストラクタ
     * @param data 学習データ
     */
    constructor(data: TrainData) {
        this._trainData = data;
    }

    /**
     * 集計処理
     */
    private _aggregate() {
        // 1行目をheaderとして処理
        const data = this._trainData.data;
        const header = data[0];
        const trainColumns: TrainColumn[] = [];

        for (let i = 0; i < header.length; i++) {
            const column = new TrainColumn(header[i], i == header.length - 1);
            trainColumns.push(column);
        }

        // rawDataデータを1行ずつ処理
        const labels: any[] = [];
        for (let i = 1; i < data.length; i++) {
            const row = data[i];
            const label = row[header.length - 1];

            // CSVの左のカラムから処理
            for (let j = 0; j < row.length; j++) {
                const column = trainColumns[j];
                const val = row[j];

                column.addData(val, label);
            }
        }

        // データを一通り走査した後に各カラムで行いたい処理を実施
        for (let i = 0; i < header.length; i++) {
            const column = trainColumns[i];
            column.processAfterAllData();
        }

        // 最初のカラムはindexなので省いて保持
        this._statistics = trainColumns.slice(1);
    }

    /**
     * getter 集計済みかどうか
     */
    private get _isAggregated(): boolean {
        return this._statistics.length > 0;
    }

    /**
     * getter 統計情報取得
     */
    public get statistics(): TrainColumn[] {
        if (!this._isAggregated) {
            this._aggregate();
        }

        return this._statistics;
    }
}
